/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Mobile_Social_Sign_In_FailedInputs */

const en_mobile_social_sign_in_failed = /** @type {(inputs: Mobile_Social_Sign_In_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.provider}: Sign-in failed`)
};

const es_mobile_social_sign_in_failed = /** @type {(inputs: Mobile_Social_Sign_In_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.provider}: no se pudo iniciar sesión`)
};

/**
* | output |
* | --- |
* | "{provider}: Sign-in failed" |
*
* @param {Mobile_Social_Sign_In_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_social_sign_in_failed = /** @type {((inputs: Mobile_Social_Sign_In_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Social_Sign_In_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_social_sign_in_failed(inputs)
	return en_mobile_social_sign_in_failed(inputs)
});